import { render, staticRenderFns } from "./Arrows.vue?vue&type=template&id=5aea9cd5&scoped=true&"
import script from "./Arrows.vue?vue&type=script&lang=js&"
export * from "./Arrows.vue?vue&type=script&lang=js&"
import style0 from "./Arrows.vue?vue&type=style&index=0&id=5aea9cd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aea9cd5",
  null
  
)

export default component.exports